export default __webpack_public_path__ + "static/media/video-1.aaac8834.mp4";